import React from 'react';
import Header from './../../../component/common/AdminHeader';
import AddUser from './../../../component/user/Add';
import Loader from './../../../component/common/Loader';

import CONSTANT from './../../../constant';
import { addUser } from './../../../actions/UserAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;
    }

    render() {
        const { showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">User detail</h1>
                            </div>
                        </div>
                        <AddUser
                            code={undefined}
                            detail={undefined}
                            onSubmit={this.onSubmit}
                        />
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onSubmit = (model: any) => {
        this.setState({ showLoader: true });
        addUser(model).then((res: any) => {
            this.setState({ showLoader: false });
            if (res.status === CONSTANT.static.apiStatus.success) {
                alert('Changes were saved successfully');
                this.props.history.push(CONSTANT.component.adminUserList.url);
            } else {
                alert(res.error);
            }
        });
    }
}

export default ComponentName;